export const proposalConstants = {
  POST_PROPOSAL_REQUEST: "JOBS_POST_REQUEST",
  POST_PROPOSAL_SUCCESS: "JOBS_POST_SUCCESS",
  POST_PROPOSAL_FAILURE: "JOBS_POST_FAILURE",

  GET_PROPOSAL_PAGINATED_REQUEST: "JOBS_GET_PAGINATED_REQUEST",
  GET_PROPOSAL_PAGINATED_SUCCESS: "JOBS_GET_PAGINATED_SUCCESS",
  GET_PROPOSAL_PAGINATED_FAILURE: "JOBS_GET_PAGINATED_FAILURE",
};
